import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseIncorrectVatValueWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.purchase.validation.incorrect-vat-value-warning.message');
    }
}
